import { translate as t } from "../localization";

const portugalTranslations = {
  "benefit-meal-tooltip-description": t(
    "benefits-section.meal-benefit.portugal-meal-tooltip-description"
  ),
  "benefit-meal-tooltip-limits": t(
    "benefits-section.meal-benefit.portugal-meal-tooltip-limits"
  ),
  "benefit-meal-tooltip-restaurants": t(
    "benefits-section.meal-benefit.portugal-meal-tooltip-restaurants"
  ),
  "benefit-meal-tooltip-food-delivery": t(
    "benefits-section.meal-benefit.portugal-meal-tooltip-food-delivery"
  ),
  "benefit-meal-tooltip-supermarkets": t(
    "benefits-section.meal-benefit.portugal-meal-tooltip-supermarkets"
  ),
  "benefit-nursery-tooltip": t(
    "benefits-section.nursery-benefit.portugal-nursery-tooltip"
  ),
  "benefit-education-tooltip": t(
    "benefits-section.education-benefit.portugal-education-tooltip"
  ),
  "nursery-advanced-config-description": t(
    "benefits-section.nursery-benefit.pt-nursery-advanced-config-description"
  ),
  "legal-notice-text": t("benefits-section.pt-legal-notice-text"),
  "health-insurance": t(
    "benefits-section.health-insurance-benefit.portugal-health-insurance"
  ),
  "health-insurance-tooltip": t(
    "benefits-section.health-insurance-benefit.portugal-health-insurance-tooltip"
  ),
  "bag-removal-tooltip-3": t("subsidy-section.portugal-bag-removal-tooltip-3"),
  "tooltip-health-insurance-1": t(
    "benefits-section.tooltips.portugal-health-insurance-1"
  ),
  "tooltip-health-insurance-2": t(
    "benefits-section.tooltips.portugal-health-insurance-2"
  ),
  "tooltip-health-insurance-3": t(
    "benefits-section.tooltips.portugal-health-insurance-3"
  ),
  "v2.benefits.health-insurance.name": `v2.benefits.medical-expense.name`,
};

export default portugalTranslations;
